var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-0",attrs:{"id":"fma-back-button","color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{staticStyle:{"font-size":"80px"}},[_vm._v(" keyboard_arrow_left ")]),_vm._v("\n  Back\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }